import { render } from "./MainLayout.vue?vue&type=template&id=2ac914d6"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import "./MainLayout.vue?vue&type=style&index=0&id=2ac914d6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__